import { FormGroup } from 'react-bootstrap';
import { Field, Form, Formik } from 'formik';
import { Trans, useTranslation } from 'react-i18next';
import { useToast } from '@arnold/common';
import { useSetConsentMutation } from '../../generated/hooks';
import auth from '../../lib/auth';
import { CheckboxGroup } from '../../components/StyledComponents';
import { FullWidthButton } from './Common';

type IProps = {
  accessToken: string;
  username: string;
  redirect?: string;
  password?: string;
};

export const GrantConsentForm = ({ accessToken, username, redirect, password }: IProps) => {
  const [t] = useTranslation('loginForm');
  const { addToast } = useToast();
  const [setConsent] = useSetConsentMutation();

  const handleOnSubmit = async (values: any) => {
    try {
      await setConsent({
        variables: { consent: values.consent },
        context: {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      });
      await auth.login(username, password, undefined, redirect || '/overview', password ? undefined : accessToken);
    } catch (e) {
      addToast(t('loginFailed'));
    }
  };

  return (
    <Formik initialValues={{ consent: false }} onSubmit={handleOnSubmit}>
      {({ handleSubmit, isSubmitting, values }) => (
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <CheckboxGroup>
              <Field type="checkbox" name="consent" />
              <span style={{ marginLeft: '18px' }}>
                <Trans
                  i18nKey={'registration:agreeWithT&C'}
                  components={[<a href={t('registration:T&CLink')} target="_blank" rel="noreferrer" />]}
                >
                  I agree with the LMC s.r.o. Terms and Conditions.
                </Trans>
              </span>
            </CheckboxGroup>
          </FormGroup>
          <div className="d-flex flex-wrap align-items-start mt-7">
            <FullWidthButton variant="primary" type="submit" disabled={isSubmitting || !values.consent}>
              {t('continue')}
            </FullWidthButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};
